<div class="modal-backdrop-custom">
  <div class="modal-box" [class]="size">
    <div class="modal-header-custom">
      <h5>{{ title }}</h5>
      <button type="button" class="close-btn" (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body-custom">
      <ng-content></ng-content>
    </div>
    <div class="modal-footer-custom">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
